/** Characters Windows (the strictest of the targets) refuses in a file name; control characters go too. */
const FORBIDDEN_FILE_NAME_CHARS = '\\/:*?"<>|';

const isForbidden = (char: string) => char.charCodeAt(0) < 0x20 || FORBIDDEN_FILE_NAME_CHARS.includes(char);

/**
 * A template name → a safe file name for a download: forbidden characters become `_`, runs of
 * whitespace one space. Shared by the media-manager and broadcast template files.
 */
export function sanitizeFileName(value: string, fallback = 'template'): string {
  const cleaned = Array.from(value, (char) => (isForbidden(char) ? '_' : char))
    .join('')
    .replace(/\s+/g, ' ')
    .trim();
  // A trailing dot or space is silently dropped by Windows — do not leave one.
  return cleaned.replace(/[. ]+$/, '') || fallback;
}
